<template>
  <base-draggable-card-view
    v-model:force-maximize="forceMaximize"
    v-model:maximized="maximized"
    card-type="top"
    x-init-pos="10px"
    class="guide-statechart-definitions-container"
  >
    <template #toolbarContent="scope">
      <div
        :style="maximized ? undefined : 'text-overflow: ellipsis; white-space: nowrap; overflow: hidden'"
        data-testid="statechartDefinitionsView.window-title-div"
      >
        Statechart Definitions
      </div>
      <v-badge v-show="showError" :color="severityColor" :content="issues" offset-y="25" offset-x="5">
        <v-btn-icon size="small" icon="mdi-alert" @click="scope.minMax()"> </v-btn-icon>
      </v-badge>
      <v-spacer></v-spacer>
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-btn-icon
            icon="mdi-help-circle-outline"
            size="small"
            v-bind="props"
            target="_blank"
            href="https://www.itemis.com/en/yakindu/state-machine/documentation/user-guide/quick_ref_definition_section"
          >
          </v-btn-icon>
        </template>
        <span>Open Documentation</span>
      </v-tooltip>
    </template>
    <template #content="scope"> <specification-editor v-show="scope.show" v-if="model" :model="model" /></template>
  </base-draggable-card-view>
</template>

<script setup lang="ts">
import { ModelEventBus, ModelLoaded, TourEventBus, UIEventBus } from "../../event-bus";
import SpecificationEditor from "./SpecificationEditor.vue";

import { Statechart } from "../mvc/statechart";

import { DiagnosticsErrorInformation, IErrorInformative } from "../services/ui/view/error-informative";
import { TextDiagnostic } from "../services/ui/text-diagnostic";
import { ref, onMounted, computed, onBeforeUnmount } from "vue";
import BaseDraggableCardView from "../../shared/BaseDraggableCardView.vue";

const showError = ref(false);
const textDiagnostic = ref<TextDiagnostic[]>([]);
const annotationsInformation = ref<IErrorInformative>(new DiagnosticsErrorInformation(textDiagnostic.value));

const model = ref<Statechart>();

const forceMaximize = ref<boolean>(false);
const maximized = ref<boolean>(false);

const issues = computed(() => {
  return annotationsInformation.value.issueCount;
});

const severityColor = computed(() => {
  return annotationsInformation.value.severityColor;
});

const setAnnotations = (annotations: TextDiagnostic[]) => {
  annotationsInformation.value.setValue(annotations);
  textDiagnostic.value = annotations;
  showError.value = issues.value > 0;
};

function forceMaximizeHandler() {
  forceMaximize.value = true;
}

onMounted(() => {
  ModelEventBus.on("modelLoaded", setModel);
  UIEventBus.on("editorValidated", setAnnotations);
  TourEventBus.on("startOnboarding", forceMaximizeHandler);
});

onBeforeUnmount(() => {
  ModelEventBus.off("modelLoaded", setModel);
  UIEventBus.off("editorValidated", setAnnotations);
  TourEventBus.off("startOnboarding", forceMaximizeHandler);
});

function setModel(event: ModelLoaded) {
  model.value = event.statechart;
}
</script>

<style scoped>
/* TODO check media queries */

/* Media queries */
/* @media (max-width: 1263.98px) {
  .guide-statechart-definitions-container {
    top: 125px;
  }
}
@media (max-width: 599.98px) {
  .guide-statechart-definitions-container {
    left: inherit;
    top: inherit;
    right: 30px;
    bottom: 0;
  }
}
@media (max-height: 564.98px) {
  .guide-statechart-definitions-container {
    left: inherit;
    top: inherit;
    right: 30px;
    bottom: 0;
  }
} */
</style>
